import React from "react";
import { Box } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { getAssetKind, getAssetPreviewUrl, isSvgAsset } from "./galleryUtils";
import useNormalizedGalleryAsset from "./useNormalizedGalleryAsset";

function GalleryAssetCard(props) {
  const { asset, assetIndex, onOpen, layout, sx } = props;
  const kind = getAssetKind(asset);
  const isSvg = isSvgAsset(asset);
  const previewUrl = useNormalizedGalleryAsset(asset) || getAssetPreviewUrl(asset);
  const title = asset?.fileName || `Asset ${assetIndex + 1}`;

  return (
    <Box
      component="button"
      type="button"
      onClick={onOpen}
      data-gallery-asset-index={assetIndex}
      sx={{
        display: "block",
        width: "100%",
        p: 0,
        border: "none",
        borderRadius: 0,
        overflow: "hidden",
        backgroundColor: "transparent",
        textAlign: "left",
        cursor: "pointer",
        transition: "opacity 180ms ease",
        ...(layout
          ? {
              gridColumn: `${layout.column + 1} / span ${layout.width}`,
              gridRow: `${layout.row + 1} / span ${layout.height}`,
            }
          : {}),
        minWidth: 0,
        minHeight: 0,
        "&:hover": {
          opacity: 0.92,
        },
        ...sx,
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          background:
            kind === "pdf"
              ? "linear-gradient(135deg, #f4ecde, #dfd0b8)"
              : "linear-gradient(135deg, #dde6f2, #c9d6e7)",
        }}
      >
        {previewUrl ? (
          <Box
            component="img"
            src={previewUrl}
            alt={title}
            sx={{
              display: "block",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              backgroundColor: isSvg ? "#ffffff" : "transparent",
              pointerEvents: "none",
              userSelect: "none",
              WebkitUserDrag: "none",
            }}
          />
        ) : (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#344055",
            }}
          >
            {kind === "pdf" ? (
              <DescriptionOutlinedIcon sx={{ fontSize: 54 }} />
            ) : (
              <ImageOutlinedIcon sx={{ fontSize: 54 }} />
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default GalleryAssetCard;
